var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conteiner",class:{ menor : _vm.altura < 50 },attrs:{"width":_vm.altura * 2}},[_c('canvas',{attrs:{"id":"miCanvas","width":_vm.altura * 2,"height":_vm.altura}}),_vm._v(" "),(_vm.showPointer)?_c('div',{staticClass:"pointer",class:_vm.temperatura}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe624fd0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/termometro.vue
// module id = 835
// module chunks = 245